/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-05-31 14:47:47
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\user\activation\locales\en-US.ts
 */
export default {
  'page.activation.txtone': 'Account activation email has been sent to your email',
  'page.activation.txtstart': 'Please in',
  'page.activation.txttime': '60 minutes',
  'page.activation.txtend': 'go to the mailbox to activate',
  'page.activation.btnback': 'Return',
  'page.activation.gotoemail': 'Please go to the mailbox to activate',
  'page.success.txtsucess': 'After successful registration, please log in and timely authenticate and improve your personal information.',
  'page.activation.txterror': 'Registration has failed',
  'page.success.login': 'Login',
  'page.success.regist': 'Re register',
};
